import Echo from 'laravel-echo';

let connection;

export default class Broadcast {
  static get connection() {
    if (!connection) {
      connection = new Echo(this.echoClientConfig());
    }

    return connection;
  }

  static user(id) {
    return this.connection.private(`user.${id}`);
  }

  /**
   * Get Laravel Echo client configuration
   *
   * @return {object}
   */
  static echoClientConfig() {
    const broadcaster = MEConfig.get('auth.broadcaster');

    let driverConfig;

    switch (broadcaster) {
      case 'pusher':
        driverConfig = this._pusherConfig();
        break;

      case 'ably':
        driverConfig = this._ablyConfig();
        break;

      default:
        throw new Error('Invalid auth broadcaster.');
    }

    return Object.assign(driverConfig, this._defaultEchoConfig());
  }

  /**
   * Default Pusher Client
   *
   * @return {object}
   */
  static _pusherConfig() {
    return {
      key: MEConfig.get('auth.pusher.key'),
      cluster: MEConfig.get('auth.pusher.cluster'),
    };
  }

  /**
   * Default Pusher Client
   *
   * @return {object}
   */
  static _ablyConfig() {
    return {
      key: MEConfig.get('auth.ably.key'),
      wsHost: MEConfig.get('auth.ably.ws-host'),
      wsPort: MEConfig.get('auth.ably.ws-port'),
      disableStats: true,
      encrypted: true,
    };
  }

  /**
   * Default Echo Config
   *
   * @return {object}
   */
  static _defaultEchoConfig(client) {
    // We must use 'pusher' broadcaster both for Pusher and Ably
    // since the last works on compatibility mode to the former.
    window.Pusher = require('pusher-js');

    const publicId = document.querySelector('meta[name="sso-public-identifier"]');
    const privateId = document.querySelector('meta[name="sso-private-identifier"]');

    return {
      broadcaster: 'pusher',
      reconnectionAttempts: MEConfig.get('auth.reconnection-attempts'),
      identifier: {
        public: publicId ? publicId.content : null,
        private: privateId ? privateId.content : null,
      }
    };
  }
}
